(function() {
$(document).on("click", "input[data-staff-event-day-entry-checkbox]", function(event) {
  var $additional_fields_container, $event_day_elem, $form, $input, $preferred_role_container, $submit_container, checked, event_id;
  $input = $(event.target);
  checked = $input.prop("checked");
  event_id = $input.data("event-id");
  console.log("checked button: checked: " + checked + ", event_id: " + event_id);
  $event_day_elem = $input.closest("[data-event-day]");
  $preferred_role_container = $event_day_elem.find("[data-event-day-preferred-role]");
  $form = $input.closest("form");
  $submit_container = $form.find("#staff_event_entry_form_" + event_id + "_submit_container");
  $additional_fields_container = $form.find("#staff_event_entry_form_" + event_id + "_additional_fields_container");
  if (checked) {
    $preferred_role_container.show();
  } else {
    $preferred_role_container.hide();
  }
  if ($form.find("input[data-staff-event-day-entry-checkbox]:checked").length > 0) {
    if (!$additional_fields_container.data("persisted")) {
      $additional_fields_container.fadeIn("fast");
    }
    return $submit_container.fadeIn("fast");
  } else {
    $additional_fields_container.fadeOut("fast");
    return $submit_container.fadeOut("fast");
  }
});

}).call(window);
